/* eslint-disable no-shadow */
import React from 'react';
import PropTypes from 'prop-types';
import config from '../../../../../../config';

import ColumnHeader, { SortType } from '../../../../ColumnHeader';
import InfoButton from '../../../../InfoButton';
import CheckboxSA from '../../../../FormElementsStandalone/CheckboxSA';

import styles from '../../../../../pages/ClubProfiles/club.scss';
import { ratingTypes } from '../../../../../utils/constants';
import { PlayersHeaderColumns } from '../../../../../pages/SearchPage/SortableColumnHeaders';
import withAuth from '../../../../hocs/withAuth';

class MembersHeader extends React.Component {
    constructor(props) {
        super(props);
        this.getDateTitle = this.getDateTitle.bind(this);
        this.addExtraSpaceInHeader = this.addExtraSpaceInHeader.bind(this);
        this.sortResults = this.sortResults.bind(this);
        this.utrType = this.props?.search?.filters && this.props?.search?.filters?.utrType === 'verified' ? 'sanctioned' : 'utr';
    }

    getDateTitle() {
        const {
            membersTabState,
        } = this.props;

        const {
            adminViewType,
            requestViewType,
            inviteViewType,
        } = membersTabState;

        switch (adminViewType) {
            case 'members':
                return 'Joined Date';
            case 'requests':
                if (requestViewType === 'Pending') {
                    return 'Requested Date';
                } if (requestViewType === 'Accepted') {
                    return 'Accepted Date';
                } if (requestViewType === 'Rejected') {
                    return 'Rejected Date';
                }
                break;
            case 'invites':
                if (inviteViewType === 'pending') {
                    return 'Invited Date';
                } if (inviteViewType === 'accepted') {
                    return 'Accepted Date';
                }
                break;
            default:
                return '';
        }
        return '';
    }

    addExtraSpaceInHeader() {
        const {
            membersTabState,
            // isAdminOrOwner,
        } = this.props;

        const {
            adminViewType,
        } = membersTabState;
        switch (adminViewType) {
            case 'members':
                return true;
            case 'requests':
                return false;
            case 'invites':
                return false;
            default:
                return false;
        }
    }

    sortResults(type, field, direction) {
        const sort = { field, order: direction };
        this.props.setSorting(sort);
    }

    render() {
        const {
            showMembershipType,
            showBillingType,
            isCollegeOrHighSchool,
            // membersTabState,
            clubDetails,
            userIsPowered,
            sortState,
            setSorting,
            filters,
            isAdminOrOwner,
            onHeaderAllSelectChange,
            showCheckboxes,
            headerAllSelected,
            auth,
            membersTabState,
        } = this.props;

        const { sportTypes } = filters;
        const showTennisContent = auth?.feedPreferences?.showTennisContent;
        const showPickleballContent = auth?.feedPreferences?.showPickleballContent;
        const showTennisHeader = sportTypes?.tennis || (!sportTypes?.tennis && !sportTypes?.pickleball && showTennisContent);
        const showPickleballHeader = sportTypes?.pickleball || (!sportTypes?.tennis && !sportTypes?.pickleball && showPickleballContent);

        const singlesRatingChoice = filters.utrType === 'verified' ? 'singlesUtr' : 'myUtrSingles';
        const doublesRatingChoice = filters.utrType === 'verified' ? 'doublesUtr' : 'myUtrDoubles';

        const singlesPkbRatingChoice = filters.utrType === 'verified' ? 'singlesPkbRating' : 'unverifiedSinglesPkbRating';
        const doublesPkbRatingChoice = filters.utrType === 'verified' ? 'doublesPkbRating' : 'unverifiedDoublesPkbRating';
        const showActionColumn = membersTabState.adminViewType === 'requests' && membersTabState.requestViewType === 'Pending';

        return (
            <div className={styles.membersHeaderWrapper}>
                <div className="d-flex">
                    {isAdminOrOwner && showCheckboxes && (
                        <div className={styles.checkbox}>
                            <CheckboxSA
                                checked={headerAllSelected}
                                onChange={() => onHeaderAllSelectChange()}
                            /><span className="d-inline-block d-md-none fs13 ml16">Select All</span>
                        </div>
                    )}
                    <PlayersHeaderColumns
                        filterType={'players'}
                        players={this.props.clubDetails.clubMembers}
                        sortResults={this.sortResults}
                        utrType={this.utrType}
                        userLoggedIn={auth.user}
                        sportTypes={this.props?.search?.filters?.sportTypes}
                        isClubMemberOrAdmin={true}
                        sortClubMembers={true}
                        sortValueForClubs={`${sortState.field}_${sortState.order}`}
                    />
                </div>
                <div className={`${styles.membersHeader} d-none d-md-flex`}>
                    <div className={`${styles.flexColumn} ${styles.playerDetailsContainer}`}>
                        <ColumnHeader
                            isSortable
                            columnName={isCollegeOrHighSchool ? 'Name' : 'Player'}
                            isSelected={sortState.field === 'firstName'}
                            sortType={sortState.order}
                            initialSort={SortType.ASC}
                            onClick={(order) => {
                                setSorting({ field: 'firstName', order });
                            }}
                        />
                    </div>
                    {showTennisHeader && (
                        <div className={`${styles.flexColumn} ${styles.utrContainer}`}>
                            <ColumnHeader
                                isSortable
                                columnName="UTR"
                                isSelected={sortState.field === singlesRatingChoice}
                                sortType={sortState.order}
                                onClick={(order) => {
                                    setSorting({ field: singlesRatingChoice, order });
                                }}
                                imgUrl="/img/v3/icons/icon-singles-black.svg"
                            />
                        </div>
                    )}
                    {showTennisHeader && (
                        <div className={`${styles.flexColumn} ${styles.utrContainer}`}>
                            <ColumnHeader
                                isSortable
                                columnName="UTR"
                                isSelected={sortState.field === doublesRatingChoice}
                                sortType={sortState.order}
                                onClick={(order) => {
                                    setSorting({ field: doublesRatingChoice, order });
                                }}
                                imgUrl="/img/v3/icons/icon-doubles-black.svg"
                            />
                        </div>
                    )}
                    {showPickleballHeader && (
                        <div className={`${styles.flexColumn} ${styles.utrContainer}`}>
                            <ColumnHeader
                                isSortable
                                columnName={`${ratingTypes.pickleball}`}
                                imgUrl="/img/v3/icons/icon-singles-black.svg"
                                isSelected={sortState.field === singlesPkbRatingChoice}
                                sortType={sortState.order}
                                onClick={(order) => {
                                    setSorting({ field: singlesPkbRatingChoice, order });
                                }}
                            />
                        </div>
                    )}
                    {showPickleballHeader && (
                        <div className={`${styles.flexColumn} ${styles.utrContainer}`}>
                            <ColumnHeader
                                isSortable
                                columnName={`${ratingTypes.pickleball}`}
                                imgUrl="/img/v3/icons/icon-doubles-black.svg"
                                isSelected={sortState.field === doublesPkbRatingChoice}
                                sortType={sortState.order}
                                onClick={(order) => {
                                    setSorting({ field: doublesPkbRatingChoice, order });
                                }}
                            />
                        </div>
                    )}
                    {!showMembershipType && this.props.isPersonal && (
                        <div className={`${styles.flexColumn} ${styles.roleContainer}`}>
                            <ColumnHeader
                                columnName={'Role'}
                                hoverText={(
                                    <React.Fragment>
                                        Your players group has {clubDetails.memberCount} out of {userIsPowered ? 25 : 12} allowed members.
                                        Please contact our <a href={`https://support.${config.siteBaseUrl}/support/tickets/new`} target="_blank" rel="noopener noreferrer"> Support Team </a>
                                        if you have questions about this limit.
                                    </React.Fragment>
                                )}
                                isSelected={sortState.field === 'status'}
                                sortType={sortState.order}
                                initialSort={SortType.ASC}
                                onClick={(order) => {
                                    setSorting({ field: 'status', order });
                                }}
                            />
                        </div>
                    )}
                    {!showMembershipType && !this.props.isPersonal && showActionColumn && (
                        <div className={`${styles.flexColumn} ${styles.roleContainer}`}>
                            <ColumnHeader
                                columnName={'Action'}
                            />
                        </div>
                    )}
                    {!showMembershipType && !this.props.isPersonal && !showActionColumn && (
                        <div className={`${styles.flexColumn} ${styles.roleContainer}`}>
                            <ColumnHeader
                                columnName={'Role'}
                                isSelected={sortState.field === 'status'}
                                sortType={sortState.order}
                                initialSort={SortType.ASC}
                                onClick={(order) => {
                                    setSorting({ field: 'status', order });
                                }}
                            />
                        </div>
                    )}
                    {showMembershipType && (
                        <div className={`${styles.flexColumn} ${styles.roleContainer}`}>
                            <ColumnHeader
                                isSortable
                                columnName="Membership Type"
                                isSelected={sortState.field === 'clubMemberships.typeId'}
                                sortType={sortState.order}
                                initialSort={SortType.ASC}
                                onClick={(order) => {
                                    setSorting({ field: 'clubMemberships.typeId', order });
                                }}
                            />
                        </div>
                    )}
                    {showBillingType && (
                        <div className={`${styles.flexColumn} ${styles.billingContainer}`}>
                            <div className={`ml16`}>
                                <ColumnHeader
                                    isSortable
                                    columnName="Power Status"
                                    hoverText={(
                                        <React.Fragment>
                                            You have used {clubDetails.currentPowerUsers} of your {clubDetails.maxPowerUsers} Power subscriptions.
                                            Please contact your account administrator or our <a href={`https://support.${config.siteBaseUrl}/support/tickets/new`} target="_blank" rel="noopener noreferrer"> Support Team </a>
                                            to purchase more subscriptions.
                                        </React.Fragment>
                                    )}
                                    isSelected={Array.isArray(sortState) && sortState[0].field === 'clubMemberships.isPower'}
                                    sortType={Array.isArray(sortState) && sortState[0].order}
                                    initialSort={SortType.ASC}
                                    onClick={(order) => {
                                        setSorting([
                                            { field: 'clubMemberships.isPower', order },
                                            { field: 'isPowered', order },
                                            { field: 'clubMemberships.roleId', order: (order === SortType.ASC ? SortType.DESC : SortType.ASC) },
                                        ]);
                                    }}
                                />
                            </div>
                        </div>
                    )}
                    <div className={`${styles.flexColumn} ${styles.dateConatiner}`}>
                        <ColumnHeader
                            isSortable
                            columnName={this.getDateTitle()}
                            isSelected={sortState.field === 'clubMemberships.intialJoinDate'}
                            sortType={sortState.order}
                            initialSort={SortType.ASC}
                            onClick={(order) => {
                                setSorting({ field: 'clubMemberships.intialJoinDate', order });
                            }}
                        />
                    </div>
                    {userIsPowered && this.addExtraSpaceInHeader() && (
                        <div className={`${styles.sanctionedContainer}`} />
                    )}
                    {!userIsPowered && this.props.isAdminOrOwner && this.props.isPersonal && (
                        <InfoButton hoverText={(
                            <React.Fragment>
                                You have used {clubDetails.memberCount} of 12 allowed members. <span className="link clickable" onClick={this.props.showUpgradeToPowerPopup}>Upgrade</span> to get more.
                            </React.Fragment>
                        )}
                        />
                    )}
                </div>
            </div>
        );
    }
}
MembersHeader.propTypes = {
    search: PropTypes.instanceOf(Object),
    filters: PropTypes.instanceOf(Object),
    sortState: PropTypes.instanceOf(Object),
    auth: PropTypes.instanceOf(Object).isRequired,
    setSorting: PropTypes.func,
    clubDetails: PropTypes.instanceOf(Object),
};

MembersHeader.defaultProps = {
    search: null,
    filters: null,
    sortState: null,
    setSorting: () => { },
    clubDetails: null,
};
export default withAuth(MembersHeader);
